import { useMutation } from '@tanstack/react-query';
import APIClient from '@/services/APIClient';
import BaseServices from '@/services/BaseServices';

const useKhaltiCheckout = ({
  cb,
  cbSuccess,
  cbError,
}: IMutationHookProps<PaymentCheckoutResponse>) => {
  return useMutation<
    PaymentCheckoutResponse,
    CustomError<RevelErrorResponse>,
    PaymentCheckoutRequest<KhaltiCheckoutPayload>
  >({
    mutationFn: ({ businessId, payload }) => {
      const apiClient = new APIClient<KhaltiCheckoutPayload>(
        BaseServices.PAYMENT_SERVICE,
        `/payment/business/${businessId}/khalti-lookup/checkout`,
      );
      return apiClient.post<PaymentCheckoutResponse>(payload);
    },
    onMutate: cb,
    onSuccess: cbSuccess,
    onError: cbError,
  });
};

export default useKhaltiCheckout;
